import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2db9df5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notifications-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ibf-h2 notifications-title" }, "Notifications")
], -1))
const _hoisted_3 = { class: "notifications-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "item !items-center" }
const _hoisted_6 = { class: "message-notifictaions-item-text" }
const _hoisted_7 = { class: "gordita-400-12 message-item-description" }
const _hoisted_8 = { class: "notifications-date gordita-400-11" }
const _hoisted_9 = {
  key: 0,
  class: "bottom-border"
}

import { useMessageNotificationsQuery } from '@/graphql/codegen/generated/graphql';
import { computed, inject } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { dateUtils } from '@/services/dateUtils';
import { NotificationType, notificationIconByType } from './const.linux';


export default /*#__PURE__*/_defineComponent({
  __name: 'messagesContent.linux',
  setup(__props) {

const coordinatorsService = inject(IKCoordinatorsService);
const GQL_userNotificationsQuery = useMessageNotificationsQuery(
  () => ({
    coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
  }),
  { fetchPolicy: 'no-cache' },
);
const notifications = computed(() => GQL_userNotificationsQuery?.result?.value?.ibManagerEntities?.notifications || []);
const notificationsContent = (text: string) => {
  const firstLetter = text.charAt(0);
  const restOfText = text.slice(1);
  return firstLetter.toUpperCase() + restOfText;
};
const getNotificationsIcon = (notificationType: NotificationType.Info | NotificationType.Error | NotificationType.Warning) => notificationIconByType[notificationType];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications).slice().reverse(), (item, i) => {
            return (_openBlock(), _createElementBlock("div", { key: i }, [
              (item?.data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["message-notifictaions-icon", getNotificationsIcon(item?.notificationType as any || 0)])
                      }, null, 2),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(notificationsContent(item?.data || '')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(dateUtils).getNotificationsUserFriendlyDate(item?.createdAt)), 1),
                    (i < _unref(notifications).length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})